import { useState } from "react";
import { Button } from "@mui/material";
import { Form } from "react-bootstrap";
import containerStyles from "utilities/styles/containerStyles.module.scss";
import styles from "features/slideShow/slideShow.module.scss";
import { useCreatePhotoCommentMutation } from "app/api/media";

const WriteCommentModal = ({ currentVerification, handleCloseModal }) => {
  const [comment, setComment] = useState<string>("");
  const [createPhotoComment] = useCreatePhotoCommentMutation();

  const mediaType = currentVerification.type === 2 ? "filmen" : "bilden";

  const submitComment = (e) => {
    e.preventDefault();
    createPhotoComment({
      checklistId: currentVerification.checklistId,
      mediaId: currentVerification.id,
      comment: comment,
    })
      .unwrap()
      .then(() => {
        setComment("");
        handleCloseModal();
      });
  };

  return (
    <div className={containerStyles.overlay}>
      <div className={styles.writeComment}>
        <Form onSubmit={submitComment}>
          <p className="fw-bold text-dark">Kommentera {mediaType}</p>
          <Form.Control
            type="text"
            autoFocus
            onChange={(e) => {
              setComment(e.target.value);
            }}
            value={comment || ""}
            className="my-3"
          />

          <div className="d-flex justify-content-center mt-2">
            <Button variant="contained" color="error" onClick={handleCloseModal} className="me-2">
              Avbryt
            </Button>
            <Button disabled={comment === ""} type="submit" variant="contained">
              Spara
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default WriteCommentModal;
